export default "__VITE_ASSET__5CxtFGef__"